export const LOAN_INPUT_STEPPER_DELTA = 500
export const LOAN_MAX_TERM = 52
export const LOAN_MIN_TERM = 17
